import { E_HEADER_TYPE } from './enums';
export const HEADER_HOME_VIEW_CONFIG = {
    logoVisible: true,
    customLogoVisible: true,
    visibleProducts: true,
    helpCenterGuiderVisible: true,
    title: '',
    left: [],
    right: [
        'slot:hiroEntry',
        'slot:timer',
    ],
};
export const HEADER_SUB_VIEW_CONFIG = {
    logoVisible: false,
    customLogoVisible: false,
    visibleProducts: true,
    helpCenterGuiderVisible: true,
    title: '',
    left: ['slot:goBack', 'slot:subViewLeft'],
    right: [
        'slot:hiroEntry',
        'slot:timer',
    ],
};
export const HEADER_SETTING_VIEW_CONFIG = {
    logoVisible: false,
    customLogoVisible: false,
    visibleProducts: true,
    helpCenterGuiderVisible: true,
    title: '',
    left: ['slot:goBack', 'slot:settingsHeaderLeft'],
    right: [
        'slot:hiroEntry',
        'slot:timer',
    ],
};
export const HEADER_DETAIL_VIEW_CONFIG = {
    logoVisible: false,
    customLogoVisible: false,
    visibleProducts: true,
    helpCenterGuiderVisible: true,
    title: '',
    left: [
        'slot:spaceHeaderLeft',
        'slot:dataSourceTabs',
    ],
    right: [
        'slot:addToNavigationSpace',
        'slot:collaborationPermissionTag',
        'slot:spaceShare',
        'slot:hiroEntry',
        'slot:timer',
    ],
};
export const HEADER_FREE_DETAIL_VIEW_CONFIG = {
    logoVisible: false,
    customLogoVisible: false,
    visibleProducts: false,
    helpCenterGuiderVisible: false,
    title: '',
    left: ['slot:spaceHeaderLeft', 'slot:dataSourceTabs'],
    right: [],
};
export const HEADER_TYPE_CONFIG_MAP = {
    [E_HEADER_TYPE.MAIN_VIEW]: HEADER_HOME_VIEW_CONFIG,
    [E_HEADER_TYPE.SUB_VIEW]: HEADER_SUB_VIEW_CONFIG,
    [E_HEADER_TYPE.SETTING_VIEW]: HEADER_SETTING_VIEW_CONFIG,
    [E_HEADER_TYPE.DETAIL_VIEW]: HEADER_DETAIL_VIEW_CONFIG,
    [E_HEADER_TYPE.FREE_DETAIL_VIEW]: HEADER_FREE_DETAIL_VIEW_CONFIG,
};
